import axios from 'axios'
import store from '../store'
import router from '../router'
import { Toast } from '@nutui/nutui'

// 创建axios实例
const service = axios.create({
  //baseURL: 'http://192.168.31.138:8201/mall-portal',
   //baseURL: 'http://guoyonghao.imwork.net:31530/mall-admin',
  //baseURL: 'http://localhost:8201/mall-admin',
  //baseURL: "http://192.168.1.195:8201/mall-portal/",
  baseURL: 'https://api.v2.cnxieku.com/mall-admin',
  timeout: 60000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  console.log(store)
  if (store.getters.sellerToken) {
    config.headers['Authorization'] = store.getters.sellerToken
  }
  return config
}, error => {
  // Do something with request error
  console.log(error)
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
    * code为非200是抛错 可结合自己业务进行修改
    */
    const res = response.data
    // debugger
    if (res.code !== 200) {
      // 401:未登录;
      if (res.code === 401) {
        // Toast.text('登录过期，请重新登录')
        store.dispatch('LogOut').then(() => { })
        router.replace({
          name: 'login',
          query: { redirect: router.currentRoute.fullPath } // 登录后再跳回此页面时要做的配置
        })
      } else {
        Toast.text(res.message)
      }
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)
    // Toast.text(error.message || '服务器忙，请稍后再试！')
    Toast.text('服务器忙，请稍后再试！')
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/requestSupplier.js